import * as React from 'react';
import { Alert, Layout, Row, Col, Card, Button, message, Tooltip } from 'antd';
import { connect } from 'react-redux';
import { withRouter } from 'react-router';
import { KeyValueDisplay } from '../key_value_display/KeyValueDisplay';
import { PageLoadingPlaceholder } from '../page_loading_placeholder/PageLoadingPlaceholder';
import {
	acceptWorkOrderForSupplier,
	appendWorkOrderNotesForSupplier,
	approveWorkOrderServiceCallForContractor,
	backDataWorkOrderForSupplier,
	cancelWorkOrderForSupplier,
	declineWorkOrderForSupplier,
	manualCheckInServiceCallForContractor,
	manualCheckInServiceCallForSupplier,
	manualCheckOutServiceCallForContractor,
	manualCheckOutServiceCallForSupplier,
	markCompletedByThirdPartyForSupplier,
	partsOrderedWorkOrderForSupplier,
	partsReceivedWorkOrderForSupplier,
	partsRequestedWorkOrderForSupplier,
	rescheduleServiceCallForContractor,
	copyContractorServiceCall,
	reviewInternalTechWorkOrderAndMarkCompleteForSupplier,
	reviewWorkOrderAndMarkCompleteForSupplier,
	reviewWorkOrderAndMarkUnsatisfactoryForSupplier,
	scheduleServiceCallForContractor,
	techEnRouteServiceCallForSupplier,
	techEnRouteContractorWorkOrder,
	updateContractWorkOrder,
	workOrdersRestCrudThunksForSupplier,
	workUnsatisfactoryContractorWorkOrder,
	finishWorkOrderForBuyer,
	finishWorkOrderForSupplier,
	startWorkOrderForBuyer,
	startWorkOrderForSupplier,
} from '../../thunks/work_orders_thunks';
import {
	compareStrings,
	getCurrency,
	getDisplayableErrorMessage,
	getEntityById,
	getPONumbers,
	disabledByAnotherAction,
	getWorkOrderTimeZoneId,
	isAdminUser,
	isCheckInModalMandatory,
	isSupplierPayingCustomer,
	nullSafeGet,
	nullSafeGetOrElse,
	stopDefaultEvents,
	canAccessInternalWorkspace,
} from '../../utils/DataAccessUtils';
import {
	CONTRACTOR_PROPS,
	DEFAULT_WORK_ORDER_PROP_ID_FOR_MANAGED_CLIENT_WO,
	ROLE_TYPES,
} from '../../utils/DataConstants';
import {
	NOT_SCHEDULABLE_STATUSES,
	SCHEDULE_TECH_STATUSES,
	WORK_ORDER_STATUSES,
} from '../../constants/WorkOrderStatuses';
import { ProtectedImageThumbnails } from '../protected_image_thumbnails/ProtectedImageThumbnails';
import moment from 'moment';
import posthog from 'posthog-js';
import FileUploader from '../file_uploader/FileUploader';
import ScheduleServiceCallModalForm from '../schedule_service_call_modal_form/ScheduleServiceCallModalForm';
import {
	rescheduleServiceCallForSupplier,
	scheduleServiceCallForSupplier,
} from '../../thunks/work_orders_thunks';
import ManualCheckInModalForm from '../manual_checkin_modal_form/ManualCheckInModalForm';
import ManualCheckOutModalForm from '../manual_checkout_modal_form/ManualCheckOutModalForm';
import SupplierLocationCardDisplay from '../supplier_location_card_display/SupplierLocationCardDisplay';
import PartsOrderedOrReceivedForm from '../parts_ordered_form/PartsOrderedOrReceivedForm';
import PartsRequestedForm from '../parts_requested_form/PartsRequestedForm';
import SupplierApproveReviewWorkForm from '../supplier_approve_review_work_form/SupplierApproveReviewWorkForm';
import SupplierRejectReviewWorkForm from '../supplier_reject_review_work_form/SupplierRejectReviewWorkForm';
import OWResult from '../OWResult';
import { markUserNotificationsReadForSupplier } from '../../thunks/user_notifications_thunks';
import { UserName } from '../name_component/user/UserNameComponent';
import { PERMISSION_NAMES, isInternalTech, isThirdPartySupplier } from '../../utils/AuthUtils';
import AccessPermissionChecker from '../common/AccessPermissionChecker';
import WorkOrderPrintable from '../WorkOrderPrintable';
import QuestionnaireSurvey from '../PostCompletionQuestionnaire/QuestionnaireSurvey';
import { updateWorkOrderResolutionTypeForSupplier } from '../../thunks/resolution_types_thunks';
import { EditOutlined, InfoCircleOutlined } from '@ant-design/icons';
import BackDateWorkOrderModalForm from '../backdate_work_order_modal_form copy/BackDateWorkOrderModalForm';
import EstimatedDateWorkOrderModalForm from '../estimated_work_order_modal_form';
import ReminderForm from '../reminder_form/ReminderForm';
import WorkOrderActions from '../work_order_actions/WorkOrderActions';
import WorkOrderInternalContact from '../work_orders_detail_details_page/WorkOrderInternalContact';
import AssetStatusForm from '../asset_status_form/AssetStatusForm';
import { assetDowntimeGet } from '../../thunks/assets_thunks';
import TroubleshootingDetailDisplay from '../work_orders_detail_details_page/TroubleshootingDetailDisplay';
import AssetCardDisplay from '../asset_card_display/AssetCardDisplay';
import ReviewAndMarkCompleteComponent from './ReviewAndMarkCompleteComponent';
import ServiceProviderCardDisplay from '../service_provider_card_display/ServiceProviderCardDisplay';
import DateTimeHover from '../date_time_component/DateTime';
import SupplierServiceCallDetails from '../work_orders_detail_details_page/SupplierServiceCallDetails';
import HyperLink from '../common/HyperLink';
import {
	getApprovedOrDeclinedDetail,
	biddingOnWorkOrderAssociatedWithAnotherSupplier,
	getSupplierWorkOrderServiceCalls,
	getSanitisedWorkOrder,
	getContractorWO,
	isDifferentAssignedSupplier,
	isMoveToOnHoldDisabled,
	isSubContractedFromWorkOrder,
} from '../../utils/WorkOrderUtils';
import WOAdditionalDetailsModal from '../work_order_tasks/WOAdditionalDetailsModal';
import SubContractorCardDisplay from '../sub_contractor_card_display/SubContractorCardDisplay';
import WOTasksSection from '../ow_inline_todo_list/WOTasksSection';
import WorkOrderRating from '../WorkOrderRating/WorkOrderRating';
import AddTasksButton from './AddTasksButton';
import InternalNotesPreviewCard from '../internal_notes_preview_card/InternalNotesPreviewCard';
import { WORK_ORDER_DISPLAY_STATUSES } from '../../constants/WorkOrderDisplayStatuses';
import { serviceCallsRestCrudThunksForSupplier } from '../../thunks/service_calls_thunks';
import CopyServiceCallForm from '../CopyServiceCallForm/CopyServiceCallForm';
import ContractorLocationDisplayCard from '../supplier_location_card_display/ContractorLocationDisplayCard';
import ContractorClientCardDisplay from '../contractor_clients/ContractorClientCardDisplay';
import SupplierAssociateAssetInWorkOrder from '../supplier_associate_asset_in_work_order/SupplierAssociateAssetInWorkOrder';
import {
	clampCheckOutToCheckIn,
	formatDateForLocationTimeZone,
} from '../../utils/DataFormatterUtils';
import { safeEncodeURIComponent } from '../../utils/HistoryUtils';
import SelfManagementServiceCall from '../self_management_service_call/SelfManagementServiceCall';
import StartWorkForm from '../start_work_form/StartWorkForm';
import FinishWorkForm from '../finish_work_form/FinishWorkForm';
import SelfManagedSupplierEmailPromptModal from '../self_managed_supplier_email_prompt_modal/SelfManagedSupplierEmailPromptModal';
import { shouldShowSelfManagedSupplierInviteBanner } from '../../utils/SelfManagedSupplierEmailPromptUtils';
import { supplierPrivateNetworksV2ForSupplier } from '../../thunks/supplier_private_networks_thunks';
import { WORK_ORDERS_CRUD_ACTION_CREATORS } from '../../actions/work_orders_actions';

const { Content } = Layout;

const queryString = require('qs');
require('./SupplierWorkOrdersDetailDetailsPage.less');

class SupplierWorkOrdersDetailPage extends React.Component<any, any> {
	formRefs: any = {
		scheduleServiceCallForm: null,
		rescheduleServiceCallForm: null,
		scheduleServiceCallForTechAssignedForm: null,
	};

	state = {
		loading: false,
		scheduleServiceCallFormVisible: false,
		rescheduleServiceCallFormVisible: false,
		manualCheckInFormVisible: false,
		manualCheckOutFormVisible: false,
		partsOrderedModalVisible: false,
		partsReceivedModalVisible: false,
		partsRequestedModalVisible: false,
		backDateWorkOrderFormVisible: false,
		estimatedDateWorkOrderFormVisible: false,
		scheduleServiceCallForTechAssignedFormVisible: false,
		approveWorkModalVisible: false,
		rejectWorkModalVisible: false,
		startWorkModalVisible: false,
		finishWorkModalVisible: false,
		locationDrawerVisible: true,
		reminderModalVisible: false,
		onlyReview: false,
		tab: 'active',
		error: null,
		addDetailModalVisible: false,
		addingDetails: false,
		actionButtonLoading: null,
		downTimeHistory: [],
		assetStatusChangeModalVisible: false,
		tasksSectionVisible: false,
		copyServiceCallFormVisible: false,
		selectedServiceCall: {},
		addAssociateAssetModalVisible: false,
		supplierRelationship: null,
		inviteSupplierModalVisible: false,
	};

	constructor(props) {
		super(props);

		const { location } = props;
		let searchString = location.search;
		if (searchString[0] === '?') {
			searchString = searchString.slice(1);
		}
		const queryParams = queryString.parse(searchString);

		if (queryParams.backlinkParams) {
			const { tab } = queryString.parse(queryParams.backlinkParams);
			this.setState({
				tab: tab ? tab : 'active',
			});
		}

		this.showApproveModal = this.showApproveModal.bind(this);
		this.showRejectModal = this.showRejectModal.bind(this);
		this.showReminderModal = this.showReminderModal.bind(this);
		this.handleApproveWorkSubmit = this.handleApproveWorkSubmit.bind(this);
		this.handleApproveWorkCancel = this.handleApproveWorkCancel.bind(this);
		this.handleRejectWorkSubmit = this.handleRejectWorkSubmit.bind(this);
		this.handleRejectWorkCancel = this.handleRejectWorkCancel.bind(this);
		this.handlePartsOrdered = this.handlePartsOrdered.bind(this);
		this.handlePartsOrderedSubmit = this.handlePartsOrderedSubmit.bind(this);
		this.handlePartsOrderedCancel = this.handlePartsOrderedCancel.bind(this);
		this.handlePartsReceived = this.handlePartsReceived.bind(this);
		this.handlePartsReceivedCancel = this.handlePartsReceivedCancel.bind(this);
		this.handlePartsReceivedSubmit = this.handlePartsReceivedSubmit.bind(this);
		this.handleStartWork = this.handleStartWork.bind(this);
	}

	refreshWorkOrder = () => {
		const {
			getWorkOrder,

			match,
		} = this.props;
		const workOrderId = match.params.id;
		const workOrder = getWorkOrder(workOrderId)
			.then((wo) => {
				this.setState({ loading: false });
				return wo;
			})
			.catch((e) => {
				this.setState({ loading: false, error: e });
			});
		return workOrder;
	};

	maybeFetchSupplierRelationship = () => {
		const { workOrder, currentUser, fetchSupplierRelationship } = this.props;
		if (!isInternalTech(currentUser)) {
			return;
		}
		const supplierFacilityId = nullSafeGet('supplierFacilityId', workOrder);
		if (!supplierFacilityId) {
			this.setState({ supplierRelationship: null });
			return;
		}
		fetchSupplierRelationship({ supplierFacilityId })
			.then((relationships) => {
				const relationship = relationships && relationships.length > 0 ? relationships[0] : null;
				this.setState({ supplierRelationship: relationship });
			})
			.catch(() => {
				this.setState({ supplierRelationship: null });
			});
	};

	handleOpenInviteSupplierModal = () => {
		this.setState({ inviteSupplierModalVisible: true });
	};

	handleCloseInviteSupplierModal = () => {
		this.setState({ inviteSupplierModalVisible: false });
	};

	isAllowedToTransferWork = () => {
		const internalTechConfig = nullSafeGet('facility.internalTechConfig', this.props.currentUser);
		return !internalTechConfig || internalTechConfig.allowedToTransferWork !== false;
	};

	handleSupplierInvitedFromBanner = (values) => {
		const { workOrder, updateWorkOrderPartiallyInRedux } = this.props;
		this.setState({ inviteSupplierModalVisible: false });
		updateWorkOrderPartiallyInRedux({
			id: workOrder.id,
			supplierFacility: {
				...nullSafeGetOrElse('supplierFacility', workOrder, {}),
				primaryContactEmail: values.primaryContactEmail,
			},
		});
		this.maybeFetchSupplierRelationship();
	};

	componentDidMount() {
		const { markUserNotificationsRead, workOrder } = this.props;
		this.maybeFetchSupplierRelationship();

		const handleMountActions = (workOrder) => {
			const { match, currentUser } = this.props;
			const action = match.params.action;
			const moveToOnHoldDisabled = isMoveToOnHoldDisabled(workOrder, currentUser, null);
			if (action === 'schedule') {
				this.setState({ scheduleServiceCallFormVisible: true });
			} else if (action === 'reschedule') {
				this.setState({ rescheduleServiceCallFormVisible: true });
			} else if (action === 'partsOrdered' && !moveToOnHoldDisabled) {
				this.setState({ partsOrderedModalVisible: true });
			} else if (action === 'partsRequested' && !moveToOnHoldDisabled) {
				this.setState({ partsRequestedModalVisible: true });
			} else if (action === 'accept') {
				this.handleAccept(workOrder);
			} else if (action === 'decline') {
				this.handleDecline(workOrder);
			} else if (action === 'edit') {
				this.handleEdit(workOrder);
			} else if (action === 'archive') {
				this.handleArchive(workOrder);
			} else if (action === 'unarchive') {
				this.handleUnarchive(workOrder);
			} else if (action === 'approve') {
				this.handleApprove(workOrder);
			} else if (action === 'cancel') {
				this.handleCancel(workOrder);
			} else if (action === 'approveWork') {
				this.setState({ approveWorkModalVisible: true });
			} else if (action === 'rejectWork') {
				this.setState({ rejectWorkModalVisible: true });
			} else if (action === 'reviewWork') {
				this.setState({ onlyReview: false, approveWorkModalVisible: true });
			} else if (action === 'reminder') {
				this.setState({ reminderModalVisible: true });
			}

			nullSafeGet('id', workOrder) && markUserNotificationsRead(workOrder.id);
		};
		if (workOrder && workOrder.id) {
			handleMountActions(workOrder);
		} else {
			this.refreshWorkOrder().then((workOrder) => {
				if (workOrder && workOrder.id) {
					handleMountActions(workOrder);
				}
			});
		}
	}
	componentDidUpdate(prevProps) {
		const { workOrder, markUserNotificationsRead } = this.props;
		const { workOrder: prevWorkOrder } = prevProps;
		if (workOrder && workOrder.id && prevWorkOrder && workOrder.id !== prevWorkOrder.id) {
			markUserNotificationsRead(workOrder.id);
		}
		const prevSupplierFacilityId = nullSafeGet('supplierFacilityId', prevWorkOrder);
		const nextSupplierFacilityId = nullSafeGet('supplierFacilityId', workOrder);
		if (prevSupplierFacilityId !== nextSupplierFacilityId) {
			this.maybeFetchSupplierRelationship();
		}
	}

	handleAssetStatusChange = () => {
		const { workOrder, getAssetDowntime } = this.props;
		const asset = nullSafeGet('asset', workOrder);
		getAssetDowntime({ assetId: asset.id }, ROLE_TYPES.SUPPLIER).then((data = []) => {
			this.setState({ downTimeHistory: data, assetStatusChangeModalVisible: true });
		});
	};
	handleAssetStatusCancel = () => {
		this.setState({ assetStatusChangeModalVisible: false });
	};
	handleAssetStatusSuccess = () => {
		this.setState({ assetStatusChangeModalVisible: false });
		this.refreshWorkOrder();
	};

	handleEdit = (workOrder) => {
		const { history } = this.props;
		history.push(`/supplier/workOrders/edit/${workOrder.id}`);
	};

	handleArchive = (workOrder) => {
		const { history, archiveWorkOrder } = this.props;
		const { tab } = this.state;
		archiveWorkOrder(workOrder).then(() => {
			history.push(`/supplier/workOrders/overview/${tab}`);
		});
	};

	handleUnarchive = (workOrder) => {
		const { history, unarchiveWorkOrder } = this.props;
		const { tab } = this.state;
		unarchiveWorkOrder(workOrder).then(() => {
			history.push(`/supplier/workOrders/overview/${tab}`);
		});
	};

	handleAccept = (workOrder) => {
		const { acceptWorkOrder } = this.props;
		acceptWorkOrder(workOrder);
	};

	handleDecline = (workOrder) => {
		const { history, declineWorkOrder, currentUser } = this.props;
		const { tab } = this.state;
		if (nullSafeGet('supplierFacilityId', workOrder) === nullSafeGet('facility.id', currentUser)) {
			declineWorkOrder(workOrder).then(() => {
				history.push(`/supplier/workOrders/overview/${tab}`);
			});
		} else {
			history.push(`/supplier/workOrders/overview/${tab}`);
		}
	};

	handleCancel = (workOrder) => {
		const { cancelWorkOrder } = this.props;
		// Reached via the ?action=cancel deep link, so there is no modal to report into. The backend
		// rejects with its own copy when a technician is checked in — surface it rather than leaving
		// the link looking like it did nothing.
		cancelWorkOrder(workOrder).catch((err) => {
			message.error(getDisplayableErrorMessage(err, 'Failed to cancel work order.'));
		});
	};

	handlebackDate = () => {
		this.setState({
			backDateWorkOrderFormVisible: true,
		});
	};
	handleEstimatedDate = () => {
		this.setState({
			estimatedDateWorkOrderFormVisible: true,
		});
	};

	handlebackDateWorkOrderCancel = (e) => {
		this.setState({
			backDateWorkOrderFormVisible: false,
		});
	};
	handleEstimatedDateWorkOrderCancel = (e) => {
		this.setState({
			estimatedDateWorkOrderFormVisible: false,
		});
	};

	handlebackDaterWorkOrderSubmit = () => {
		const { backDataWorkOrder, workOrder } = this.props;

		const form = this.formRefs['backDaterWorkOrderForm'].props.form;
		form.validateFields((err, values) => {
			if (err) {
				return;
			}

			backDataWorkOrder(workOrder, values.reportedAt.utc().format()).then(() => {
				this.setState({ backDateWorkOrderFormVisible: false });
				message.success(`Work order Updated`);
				this.refreshWorkOrder();
			});
		});
	};
	handleEstimatedDateWorkOrderSubmit = () => {
		const { updateWorkOrderPartially, workOrder, isClientView, updateSubContractorInfo } =
			this.props;

		const form = this.formRefs['estimatedDaterWorkOrderForm'].props.form;
		form.validateFields((err, values) => {
			if (err) {
				return;
			}

			const contractorWO = getContractorWO(workOrder, isClientView);

			if (contractorWO) {
				const newContractorWO = {
					id: contractorWO.id,
					subEstimatedCompletionDate: values.estimatedCompletionDate.utc().format(),
				};
				updateSubContractorInfo(newContractorWO).then(() => {
					this.setState({ estimatedDateWorkOrderFormVisible: false });
					message.success(`Work order Updated`);
					this.refreshWorkOrder();
				});
			} else {
				updateWorkOrderPartially(workOrder.id, {
					estimatedCompletionDate: values.estimatedCompletionDate.utc().format(),
				}).then(() => {
					this.setState({ estimatedDateWorkOrderFormVisible: false });
					message.success(`Work order Updated`);
					this.refreshWorkOrder();
				});
			}
		});
	};

	handleFileAttachmentUploadChange = (newAttachments) => {
		const {
			workOrder,
			updateWorkOrderPartially,
			currentUser,
			isClientView,
			updateSubContractorInfo,
		} = this.props;
		const isPrivateSupplier = nullSafeGet('facility.status', currentUser) === 'private';
		const contractorWO = getContractorWO(workOrder, isClientView);

		if (contractorWO) {
			updateSubContractorInfo({
				id: contractorWO.id,
				[isClientView ? 'subContractorAttachments' : 'contractorAttachments']: newAttachments,
			});
		} else {
			const newWorkOrder = {
				...(isPrivateSupplier
					? { buyerAttachments: newAttachments }
					: { supplierAttachments: newAttachments }),
			};
			updateWorkOrderPartially(workOrder.id, newWorkOrder);
		}
	};

	handlePartsOrdered = (e) => {
		this.setState({
			partsOrderedModalVisible: true,
		});
		e.stopPropagation();
		e.preventDefault();
	};

	handlePartsReceived = (e) => {
		this.setState({
			partsReceivedModalVisible: true,
		});
		e.stopPropagation();
		e.preventDefault();
	};

	handlePartsOrderedSubmit = () => {
		const { currentUser, partsOrderedWorkOrder, workOrder } = this.props;
		const form = this.formRefs['partsOrderedForm'].props.form;
		form.validateFields((err, values) => {
			if (err) {
				return;
			}

			if (values.note) {
				const note = {
					text: values.note,
					noteAddedBy: currentUser.email,
					noteAddedAt: moment.utc(),
				};
				partsOrderedWorkOrder({ ...workOrder, note })
					.then(() => {
						this.setState({ partsOrderedModalVisible: false });
						this.refreshWorkOrder();
						message.success(`Parts ordered.`);
					})
					.catch((err) => {
						message.error(getDisplayableErrorMessage(err, 'Failed to mark parts ordered.'));
					});
			} else {
				partsOrderedWorkOrder(workOrder)
					.then(() => {
						this.setState({ partsOrderedModalVisible: false });
						this.refreshWorkOrder();
						message.success(`Parts ordered.`);
					})
					.catch((err) => {
						message.error(getDisplayableErrorMessage(err, 'Failed to mark parts ordered.'));
					});
			}
		});
	};

	handlePartsReceivedSubmit = () => {
		const { currentUser, partsReceivedWorkOrder, workOrder } = this.props;
		const form = this.formRefs['partsReceivedForm'].props.form;
		form.validateFields((err, values) => {
			if (err) {
				return;
			}

			if (values.note) {
				const note = {
					text: values.note,
					noteAddedBy: currentUser.email,
					noteAddedAt: moment.utc(),
				};
				partsReceivedWorkOrder({ ...workOrder, note }).then(() => {
					this.setState({ partsReceivedModalVisible: false });
					this.refreshWorkOrder();
					message.success(`Parts Received.`);
				});
			} else {
				partsReceivedWorkOrder(workOrder).then(() => {
					this.setState({ partsReceivedModalVisible: false });
					this.refreshWorkOrder();
					message.success(`Parts ordered.`);
				});
			}
		});
	};

	handlePartsOrderedCancel = (e) => {
		this.setState({
			partsOrderedModalVisible: false,
		});
	};

	handlePartsReceivedCancel = (e) => {
		this.setState({
			partsReceivedModalVisible: false,
		});
	};

	handlePartsRequested = (e) => {
		this.setState({
			partsRequestedModalVisible: true,
		});
		e.stopPropagation();
		e.preventDefault();
	};

	handlePartsRequestedSubmit = () => {
		const { partsRequestedWorkOrder, currentUser, workOrder } = this.props;
		const form = this.formRefs['partsRequestedForm'].props.form;
		form.validateFields((err, values) => {
			if (err) {
				return;
			}

			if (values.note) {
				const note = {
					text: values.note,
					noteAddedBy: currentUser.email,
					noteAddedAt: moment.utc(),
				};

				partsRequestedWorkOrder({ ...workOrder, note: note })
					.then(() => {
						this.setState({ partsRequestedModalVisible: false });
						this.refreshWorkOrder();
						message.success(`Parts requested.`);
					})
					.catch((err) => {
						message.error(getDisplayableErrorMessage(err, 'Failed to request parts.'));
					});
			} else {
				partsRequestedWorkOrder(workOrder)
					.then(() => {
						this.setState({ partsRequestedModalVisible: false });
						this.refreshWorkOrder();
						message.success(`Parts requested.`);
					})
					.catch((err) => {
						message.error(getDisplayableErrorMessage(err, 'Failed to request parts.'));
					});
			}
		});
	};

	copyServiceCall = (serviceCall) => {
		const { workOrder, currentUser } = this.props;
		const contractorWO = getContractorWO(workOrder, true);
		let newServiceCall = {
			...serviceCall,
			id: undefined,
			supplierFacilityId: currentUser.facilityId,
			checkInByEmail: currentUser.email,
			leadTechnicianEmail: currentUser.email,
			additionalTechnicianEmails: [],
			checkOutByEmail: currentUser.email,
		};

		if (contractorWO) {
			newServiceCall.contractorWorkOrderId = contractorWO.id;
			newServiceCall.workOrderId = undefined;
		} else {
			newServiceCall.contractorWorkOrderId = undefined;
			newServiceCall.workOrderId = workOrder.id;
		}
		this.setState({ selectedServiceCall: newServiceCall, copyServiceCallFormVisible: true });
	};

	copyServiceCallSubmit = () => {
		const { workOrder, copyContractorServiceCallAction, createServiceCall } = this.props;
		const form = this.formRefs['copyServiceCallForm'].props.form;
		form.validateFields((err, values) => {
			if (err) {
				return;
			}
			let action = createServiceCall;
			const contractorWO = getContractorWO(workOrder, true);
			if (contractorWO) {
				action = copyContractorServiceCallAction;
			}
			action(values)
				.then((updatedWorkOrder) => {
					this.refreshWorkOrder();
					message.success(`Service Call Copied`);
				})
				.catch((err) => {
					message.error(getDisplayableErrorMessage(err, 'Failed to copy service call.'));
				})
				.finally(() => this.setState({ copyServiceCallFormVisible: false }));
		});
	};

	copyServiceCallCancel = (values) => {
		this.setState({ copyServiceCallFormVisible: false });
	};

	handlePartsRequestedCancel = (e) => {
		this.setState({
			partsRequestedModalVisible: false,
		});
	};

	handleTechEnRoute = (e) => {
		const {
			workOrder,
			handleTechEnRouteServiceCall,
			handleTechEnRouteServiceCallForContractor,
			isClientView,
		} = this.props;
		this.setState({ actionButtonLoading: 'techEnRoute' });
		const contractorWO = getContractorWO(workOrder, isClientView);
		const action = contractorWO
			? handleTechEnRouteServiceCallForContractor
			: handleTechEnRouteServiceCall;

		action(workOrder, isClientView ? CONTRACTOR_PROPS.FROM_WO : CONTRACTOR_PROPS.TO_WO)
			.then(() => {
				message.success(`Tech marked as en route.`);
				this.refreshWorkOrder();
			})
			.catch(() => {
				message.error(`Something went wrong. Please try again.`);
			})
			.finally(() => {
				this.setState({ actionButtonLoading: null });
			});
		stopDefaultEvents(e);
	};

	scheduleAndTechEnRoute = (e) => {
		const {
			workOrder,
			currentUser,
			scheduleServiceCall,
			scheduleServiceCallForContractor,
			handleTechEnRouteServiceCall,
			handleTechEnRouteServiceCallForContractor,
			isClientView,
		} = this.props;
		this.setState({ actionButtonLoading: 'scheduleAndTechEnRoute' });

		const contractorWO = getContractorWO(workOrder, isClientView);

		const serviceCall = {
			workOrderId: workOrder.id,
			supplierFacilityId: workOrder.supplierFacilityId,
			serviceScheduledAt: moment().toISOString(),
			leadTechnicianEmail: currentUser.email,
			additionalTechnicianEmails: [],
			stockLocationIds: [],
		};

		let scheduleAction = scheduleServiceCall;
		if (contractorWO) {
			scheduleAction = scheduleServiceCallForContractor;
			serviceCall.contractorWorkOrderId = contractorWO.id;
			serviceCall.supplierFacilityId = contractorWO.subSupplierFacilityId;
			serviceCall.workOrderId = undefined;
		}

		const enRouteAction = contractorWO
			? handleTechEnRouteServiceCallForContractor
			: handleTechEnRouteServiceCall;

		scheduleAction(serviceCall)
			.then(() =>
				enRouteAction(workOrder, isClientView ? CONTRACTOR_PROPS.FROM_WO : CONTRACTOR_PROPS.TO_WO)
			)
			.then(() => {
				message.success(`Tech marked as en route.`);
				this.refreshWorkOrder();
			})
			.catch(() => {
				message.error(`Something went wrong. Please try again.`);
			})
			.finally(() => {
				this.setState({ actionButtonLoading: null });
			});
		stopDefaultEvents(e);
	};

	handleSchedule = (e) => {
		this.setState({
			scheduleServiceCallFormVisible: true,
		});
		stopDefaultEvents(e);
	};

	handleScheduleForTechAssigned = (e) => {
		stopDefaultEvents(e);
		this.setState({
			scheduleServiceCallForTechAssignedFormVisible: true,
		});
	};

	handleReschedule = (e) => {
		this.setState({
			rescheduleServiceCallFormVisible: true,
		});
		stopDefaultEvents(e);
	};

	handleManualCheckIn = (e?) => {
		this.setState({
			manualCheckInFormVisible: true,
		});
		e && stopDefaultEvents(e);
	};

	handleManualCheckOut = (e) => {
		this.setState({
			manualCheckOutFormVisible: true,
		});
		stopDefaultEvents(e);
	};

	handleScheduleServiceCallSubmit = () => {
		const { scheduleServiceCall, workOrder, isClientView, scheduleServiceCallForContractor } =
			this.props;
		const form = this.formRefs['scheduleServiceCallForm'].props.form;
		form.validateFields((err, values) => {
			if (err) {
				return;
			}
			const timeZone =
				values['serviceScheduledAtTimeZone'] || nullSafeGet('location.timeZoneId', workOrder);
			const contractorWO = getContractorWO(workOrder, isClientView);

			if (contractorWO) {
				scheduleServiceCallForContractor({
					...values,
					serviceScheduledAt: formatDateForLocationTimeZone(values.serviceScheduledAt, timeZone),
					contractorWorkOrderId: contractorWO.id,
					supplierFacilityId: contractorWO.subSupplierFacilityId,
					workOrderId: undefined,
				}).then(() => {
					this.setState({ scheduleServiceCallFormVisible: false });
					this.refreshWorkOrder();
					message.success(`Service call scheduled.`);
				});
			} else {
				scheduleServiceCall({
					...values,
					serviceScheduledAt: formatDateForLocationTimeZone(values.serviceScheduledAt, timeZone),
				}).then(() => {
					this.setState({ scheduleServiceCallFormVisible: false });
					this.refreshWorkOrder();
					message.success(`Service call scheduled.`);
				});
			}
		});
	};

	handleScheduleServiceCallCancel = (e) => {
		this.setState({
			scheduleServiceCallFormVisible: false,
		});
	};

	handleRescheduleServiceCallSubmit = () => {
		const { rescheduleServiceCall, rescheduleServiceCallForContractor, workOrder, isClientView } =
			this.props;
		const form = this.formRefs['rescheduleServiceCallForm'].props.form;
		form.validateFields((err, values) => {
			if (err) {
				return;
			}
			const timeZone =
				values['serviceScheduledAtTimeZone'] || nullSafeGet('location.timeZoneId', workOrder);
			const contractorWO = getContractorWO(workOrder, isClientView);

			if (contractorWO) {
				rescheduleServiceCallForContractor({
					...values,
					serviceScheduledAt: formatDateForLocationTimeZone(values.serviceScheduledAt, timeZone),
					contractorWorkOrderId: contractorWO.id,
					supplierFacilityId: contractorWO.subSupplierFacilityId,
					workOrderId: undefined,
				}).then(() => {
					this.setState({ rescheduleServiceCallFormVisible: false });
					this.refreshWorkOrder();
					message.success(`Service call rescheduled.`);
				});
			} else {
				rescheduleServiceCall({
					...values,
					serviceScheduledAt: formatDateForLocationTimeZone(values.serviceScheduledAt, timeZone),
				}).then(() => {
					this.setState({ rescheduleServiceCallFormVisible: false });
					this.refreshWorkOrder();
					message.success(`Service call rescheduled.`);
				});
			}
		});
	};

	handleScheduleServiceCallForTechAssignedSubmit = () => {
		const { scheduleServiceCall, workOrder, isClientView, scheduleServiceCallForContractor } =
			this.props;
		const form = this.formRefs['scheduleServiceCallForTechAssignedForm'].props.form;
		form.validateFields((err, values) => {
			if (err) {
				return;
			}
			const timeZone =
				values['serviceScheduledAtTimeZone'] || nullSafeGet('location.timeZoneId', workOrder);
			const contractorWO = getContractorWO(workOrder, isClientView);

			if (contractorWO) {
				scheduleServiceCallForContractor({
					...values,
					serviceScheduledAt: formatDateForLocationTimeZone(values.serviceScheduledAt, timeZone),
					contractorWorkOrderId: contractorWO.id,
					supplierFacilityId: contractorWO.subSupplierFacilityId,
					workOrderId: undefined,
				}).then(() => {
					this.setState({ scheduleServiceCallFormVisible: false });
					this.refreshWorkOrder();
					message.success(`Service call scheduled.`);
				});
			} else {
				scheduleServiceCall({
					...values,
					serviceScheduledAt: formatDateForLocationTimeZone(values.serviceScheduledAt, timeZone),
				}).then(() => {
					this.setState({ scheduleServiceCallForTechAssignedFormVisible: false });
					this.refreshWorkOrder();
					message.success(`Service call scheduled.`);
				});
			}
		});
	};

	handleRescheduleServiceCallCancel = (e) => {
		this.setState({
			rescheduleServiceCallFormVisible: false,
		});
	};

	handleScheduleForTechAssignedCancel = () =>
		this.setState({
			scheduleServiceCallForTechAssignedFormVisible: false,
		});

	scheduleServiceCallWithManualCheckin = (serviceCall) => {
		const {
			manualCheckIn,
			scheduleServiceCall,
			workOrder,
			isClientView,
			currentUser,
			scheduleServiceCallForContractor,
			manualCheckInForContractor,
		} = this.props;

		this.setState({ actionButtonLoading: 'startWork' });
		let action = scheduleServiceCall;
		const contractorWO = getContractorWO(workOrder, isClientView);
		if (contractorWO) {
			action = scheduleServiceCallForContractor;
			serviceCall.contractorWorkOrderId = contractorWO.id;
			serviceCall.supplierFacilityId = contractorWO.subSupplierFacilityId;
			serviceCall.workOrderId = undefined;
		}

		action(serviceCall)
			.then((updatedWorkOrder) => {
				if (isCheckInModalMandatory(workOrder, currentUser)) {
					this.handleManualCheckIn();
				} else {
					if (contractorWO) {
						const lastServiceCall = nullSafeGetOrElse(
							'lastContractorServiceCall',
							updatedWorkOrder,
							{}
						);
						const updatedServiceCall = {
							...lastServiceCall,
							checkInByEmail: currentUser.email,
							checkInTime: moment(),
							checkInNotes: undefined,
							checkInPhotos: [],
						};
						manualCheckInForContractor(updatedServiceCall).then(() => {
							this.refreshWorkOrder();
							message.success(`Work started.`);
						});
					} else {
						const lastServiceCall = nullSafeGetOrElse('lastServiceCall', updatedWorkOrder, {});
						const updatedServiceCall = {
							...lastServiceCall,
							checkInByEmail: currentUser.email,
							checkInTime: moment(),
							checkInNotes: undefined,
							checkInPhotos: [],
						};
						manualCheckIn(updatedServiceCall).then(() => {
							this.refreshWorkOrder();
							message.success(`Work started.`);
						});
					}
				}
			})
			.finally(() => this.setState({ actionButtonLoading: null }));
	};

	handleStartWork = () => {
		const { workOrder, currentUser } = this.props;

		const serviceCall = {
			workOrderId: workOrder.id,
			supplierFacilityId: workOrder.supplierFacilityId,
			serviceScheduledAt: moment(),
			leadTechnicianEmail: currentUser.email,
			additionalTechnicianEmails: [],
			stockLocationIds: [],
		};

		this.scheduleServiceCallWithManualCheckin(serviceCall);
	};

	handleSelfManagedStartWork = (e) => {
		this.setState({
			startWorkModalVisible: true,
		});
		e.stopPropagation();
		e.preventDefault();
	};

	handleSelfManagedStartWorkSubmit = () => {
		const { startWorkOrder, currentUser, workOrder } = this.props;
		const form = this.formRefs['startWorkForm'].props.form;
		form.validateFields((err, values) => {
			if (err) {
				return;
			}

			if (values.note) {
				const note = {
					text: values.note,
					noteAddedBy: currentUser.email,
					noteAddedAt: moment.utc(),
				};

				startWorkOrder({ ...workOrder, note: note }).then(() => {
					this.setState({ startWorkModalVisible: false });
					this.refreshWorkOrder();
					message.success(`Work started.`);
				});
			} else {
				startWorkOrder(workOrder).then(() => {
					this.setState({ startWorkModalVisible: false });
					this.refreshWorkOrder();
					message.success(`Work started.`);
				});
			}
		});
	};

	handleSelfManagedStartWorkCancel = () => {
		this.setState({
			startWorkModalVisible: false,
		});
	};

	handleStartWorkForTechAssigned = () => {
		const { workOrder } = this.props;

		if (!workOrder.lastServiceCall) {
			return;
		}

		const serviceCall = {
			...workOrder.lastServiceCall,
			serviceScheduledAt: moment(),
		};

		this.scheduleServiceCallWithManualCheckin(serviceCall);
	};

	handleManualCheckInSubmit = () => {
		const { manualCheckIn, manualCheckInForContractor, workOrder } = this.props;
		const form = this.formRefs['manualCheckInForm'].props.form;
		form.validateFields((err, values) => {
			if (err) {
				return;
			}
			// Destructure composite checkInNotes value from TextAreaWithAudio
			const { text: checkInNotes, audioUrl: checkInAudio } = values.checkInNotes || {};
			values.checkInNotes = checkInNotes;
			values.checkInAudio = checkInAudio;

			const contractorWO = getContractorWO(workOrder, this.props.isClientView);
			const timeZone = values['checkInTimeZone'] || nullSafeGet('location.timeZoneId', workOrder);

			if (contractorWO) {
				manualCheckInForContractor({
					...values,
					checkInTime: formatDateForLocationTimeZone(values.checkInTime, timeZone),
				}).then(() => {
					this.setState({ manualCheckInFormVisible: false });
					this.refreshWorkOrder();
					message.success(`Manually checked in.`);
				});
			} else {
				manualCheckIn({
					...values,
					checkInTime: formatDateForLocationTimeZone(values.checkInTime, timeZone),
				}).then(() => {
					this.setState({ manualCheckInFormVisible: false });
					this.refreshWorkOrder();
					message.success(`Manually checked in.`);
				});
			}
		});
	};

	handleManualCheckInCancel = (e) => {
		this.setState({
			manualCheckInFormVisible: false,
		});
	};

	handleManualCheckOutSubmit = () => {
		const {
			updateSubContractorInfo,
			manualCheckOut,
			updateWorkOrderResolutionType,
			workOrder,
			updateWorkOrderPartially,
			manualCheckOutForContractor,
		} = this.props;
		const form = this.formRefs['manualCheckOutForm'].props.form;
		form.validateFields((err, values) => {
			if (err) {
				return;
			}
			// Destructure composite checkOutNotes value from TextAreaWithAudio
			const { text: checkOutNotes, audioUrl: checkOutAudio } = values.checkOutNotes || {};
			values.checkOutNotes = checkOutNotes;
			values.checkOutAudio = checkOutAudio;

			const contractorWO = getContractorWO(workOrder, this.props.isClientView);
			const timeZone = values['checkOutTimeZone'] || nullSafeGet('location.timeZoneId', workOrder);
			const checkOutTime = clampCheckOutToCheckIn(
				nullSafeGet('lastServiceCall.checkInTime', workOrder),
				formatDateForLocationTimeZone(values.checkOutTime, timeZone)
			);
			const formValues = {
				...values,
				checkOutTime,
			};
			const checkOutAction = contractorWO ? manualCheckOutForContractor : manualCheckOut;
			const estimatedCompletionDate =
				values.estimatedCompletionDate && values.estimatedCompletionDate.utc().format();
			const estimatedCompletionDateUpdate = estimatedCompletionDate
				? (contractorWO
						? updateSubContractorInfo({
								id: contractorWO.id,
								subEstimatedCompletionDate: estimatedCompletionDate,
						  })
						: updateWorkOrderPartially(workOrder.id, { estimatedCompletionDate })
				  ).then(() => {
						this.setState({ estimatedDateWorkOrderFormVisible: false });
						message.success(`Work order Updated`);
						this.refreshWorkOrder();
				  })
				: Promise.resolve();
			estimatedCompletionDateUpdate
				.then(
					() =>
						values.resolutionTypeId &&
						updateWorkOrderResolutionType(workOrder.id, values.resolutionTypeId)
				)
				.then(() => checkOutAction(formValues))
				.then(() => {
					this.setState({ manualCheckOutFormVisible: false });
					this.refreshWorkOrder();
					message.success(`Manually checked out.`);
				})
				.catch((err) => message.error(getDisplayableErrorMessage(err, 'Failed to check out.')));
		});
	};

	handleManualCheckOutCancel = (e) => {
		this.setState({
			manualCheckOutFormVisible: false,
		});
	};

	saveFormRef = (formName) => (formRef) => {
		this.formRefs[formName] = formRef;
	};

	handleFinishWork = (e) => {
		this.setState({
			finishWorkModalVisible: true,
		});
		e.stopPropagation();
		e.preventDefault();
	};

	handleFinishWorkSubmit = () => {
		const { finishWorkOrder, currentUser } = this.props;
		const form = this.formRefs['finishWorkForm'].props.form;
		form.validateFields((err, values) => {
			if (err) {
				return;
			}

			if (values.note) {
				const note = {
					text: values.note,
					noteAddedBy: currentUser.email,
					noteAddedAt: moment.utc(),
				};
				finishWorkOrder({ id: values.workOrderId, note }).then(() => {
					this.setState({ finishWorkModalVisible: false });
					this.refreshWorkOrder();
					message.success(`Work finished.`);
				});
			} else {
				finishWorkOrder({ id: values.workOrderId }).then(() => {
					this.setState({ finishWorkModalVisible: false });
					this.refreshWorkOrder();
					message.success(`Work finished.`);
				});
			}
		});
	};

	handleFinishWorkCancel = () => {
		this.setState({
			finishWorkModalVisible: false,
		});
	};

	//Approve/Reject Work
	handleApprove = (workOrder) => {
		const { history } = this.props;
		history.push(`/supplier/workOrders/approve/${workOrder.id}`);
	};

	handleApproveWorkCancel(e) {
		this.setState({
			approveWorkModalVisible: false,
		});
	}

	showApproveModal(e) {
		this.setState({
			onlyReview: false,
			approveWorkModalVisible: true,
		});
	}

	handleRejectContractorWO = (note) => {
		const { handleWorkUnsatifactoryForContractor, isClientView, workOrder } = this.props;
		const contractorWO = getContractorWO(workOrder, isClientView);
		const contractorWOKey = isClientView ? CONTRACTOR_PROPS.FROM_WO : CONTRACTOR_PROPS.TO_WO;

		const payload = {
			id: nullSafeGet('id', contractorWO),
			note,
		};

		const entity = {
			...workOrder,
			[contractorWOKey]: payload,
		};

		handleWorkUnsatifactoryForContractor(entity, contractorWOKey).then(() => {
			this.setState({ rejectWorkModalVisible: false });
			message.success(`Work rejected.`);
		});
	};

	handleRejectWO = (values, note) => {
		const { reviewWorkOrderAndMarkUnsatisfactory } = this.props;
		const workOrderStatusChangeDetails = {
			id: values.workOrderId,
			note,
		};
		reviewWorkOrderAndMarkUnsatisfactory(workOrderStatusChangeDetails).then(() => {
			this.setState({ rejectWorkModalVisible: false });
			message.success(`Work rejected.`);
		});
	};

	handleRejectWorkSubmit() {
		const { currentUser, isClientView, workOrder } = this.props;
		const form = this.formRefs['supplierRejectReviewWorkForm'].props.form;
		form.validateFields((err, values) => {
			if (err) {
				return;
			}

			const note = {
				text: values.note,
				noteAddedBy: currentUser.email,
				noteAddedAt: moment.utc(),
			};

			const contractorWO = getContractorWO(workOrder, isClientView);

			contractorWO ? this.handleRejectContractorWO(note) : this.handleRejectWO(values, note);
		});
	}

	handleRejectWorkCancel(e) {
		this.setState({
			rejectWorkModalVisible: false,
		});
	}

	showRejectModal(e) {
		this.setState({
			rejectWorkModalVisible: true,
		});
	}

	handleReminderSubmit = () => {
		const { appendWorkOrderNotes, currentUser, workOrder } = this.props;
		const form = this.formRefs['reminderForm'].props.form;

		form.validateFields((err, values) => {
			if (err) {
				return;
			}

			const note = {
				text: values.note,
				noteAddedBy: currentUser.email,
				noteAddedAt: moment.utc(),
			};
			const workOrderNoteDetails = {
				id: values.workOrderId,
				locationId: workOrder.locationId,
				note,
			};

			appendWorkOrderNotes(workOrderNoteDetails).then(() => {
				this.setState({ reminderModalVisible: false });
				message.success(`reminder sent.`);
			});
		});
	};

	handleReminderCancel = () => {
		this.setState({
			reminderModalVisible: false,
		});
	};

	showReminderModal = () => {
		this.setState({
			reminderModalVisible: true,
		});
	};

	markWorkOrderWaitingForReview = () => {
		const { markCompletedByThirdParty, workOrder } = this.props;

		return new Promise((resolve, reject) => {
			markCompletedByThirdParty({
				id: workOrder.id,
			})
				.then(() => {
					this.setState({ approveWorkModalVisible: false });
					message.success(`Work approved.`);
					resolve(true);
				})
				.catch((err) => {
					message.error(err);
					reject(err);
				});
		});
	};

	handleApproveWorkSubmit(values) {
		const {
			reviewWorkOrderAndMarkComplete,
			reviewInternalTechWorkOrderAndMarkComplete,
			workOrder,
			currentUser,
			isClientView,
			approveWorkOrderServiceCallForContractor,
		} = this.props;

		const note = values.note
			? {
					text: values.note,
					noteAddedBy: currentUser.email,
					noteAddedAt: moment.utc(),
			  }
			: undefined;

		const isInternalServiceTeamWO = nullSafeGet('supplierFacility.status', workOrder) === 'private';

		const workOrderStatusChangeDetails = {
			id: workOrder.id,
			...(!!note && { note }),
		};

		const reviewMethod = isInternalServiceTeamWO
			? reviewInternalTechWorkOrderAndMarkComplete
			: reviewWorkOrderAndMarkComplete;

		const contractorWO = getContractorWO(workOrder, isClientView);
		if (contractorWO) {
			approveWorkOrderServiceCallForContractor({
				...values,
				note: note,
				id: contractorWO.id,
				supplierFacilityId: contractorWO.subSupplierFacilityId,
				workOrderId: undefined,
			}).then(() => {
				this.setState({ approveWorkModalVisible: false });
				this.refreshWorkOrder();
				message.success(`Work approved.`);
			});
		} else {
			reviewMethod(workOrderStatusChangeDetails)
				.then(() => {
					this.setState({ approveWorkModalVisible: false });
					message.success(`Work approved.`);
				})
				.catch((err) => message.error(err));
		}
	}

	showAddDetailModal = () => this.setState({ addDetailModalVisible: true });

	hideAddDetailModal = () => this.setState({ addDetailModalVisible: false });

	onAddDetailSuccess = () => {
		this.hideAddDetailModal();
	};

	showAssociateAssetModal = () => this.setState({ addAssociateAssetModalVisible: true });

	hideAssociateAssetModal = () => this.setState({ addAssociateAssetModalVisible: false });

	onAssociateAssetSuccess = () => {
		this.hideAssociateAssetModal();
	};

	showAddTasks = () => this.setState({ tasksSectionVisible: true });

	render() {
		const { workOrder, currentUser, companyConfig, history, userType, isClientView } = this.props;

		const allowAssetAssociationByThirdPartySuppliers =
			isThirdPartySupplier(currentUser) &&
			nullSafeGetOrElse(
				'buyerCompany.buyerCompanySettings.config.workOrder.allowAssetAssociationByThirdPartySuppliers',
				workOrder,
				false
			);

		const { loading, error } = this.state;

		const contractorWO = getContractorWO(workOrder, isClientView);

		const internalTechAllowedToComplete = nullSafeGetOrElse(
			'facility.internalTechConfig',
			currentUser,
			{}
		).allowedOneClickCompletion;

		const reviewAndCompleteAllowed = isInternalTech(currentUser)
			? typeof internalTechAllowedToComplete === 'undefined'
				? true
				: internalTechAllowedToComplete
			: nullSafeGetOrElse(
					'buyerCompany.buyerCompanySettings.config.workOrder.thirdPartySuppliersAllowedOneClickCompletion',
					workOrder,
					false
			  );

		const isPrivateSupplier = nullSafeGet('facility.status', currentUser) === 'private';
		const differentAssignedSupplier = isDifferentAssignedSupplier(workOrder, currentUser);
		const isTechEnRouteEnabled = posthog.isFeatureEnabled('tech-enroute-status');
		let optionalDetails = {};
		if (workOrder.isWarranty) {
			optionalDetails['Warranty Status'] = 'Under Warranty';
		}
		const isSupplierInitiated = nullSafeGet('isSupplierInitiated', workOrder);

		const bidderReadWO = biddingOnWorkOrderAssociatedWithAnotherSupplier(workOrder, currentUser);

		const supplierCurrency = getCurrency({ workOrder });
		const approvedOrDeclinedByContactDetail = getApprovedOrDeclinedDetail(workOrder);

		const sanitizedWO = getSanitisedWorkOrder(workOrder, isClientView);
		const contractWO = getContractorWO(workOrder, isClientView);
		const buyerSettingsLoaded =
			!!nullSafeGet('buyerCompany.buyerCompanySettings', workOrder) ||
			nullSafeGet('buyerCompanyId', workOrder) === DEFAULT_WORK_ORDER_PROP_ID_FOR_MANAGED_CLIENT_WO;
		const skipNTEVisibilityToSuppliers = nullSafeGetOrElse(
			'buyerCompany.buyerCompanySettings.config.suppliersConfig.skipNTEVisibilityToSuppliers',
			workOrder,
			false
		);
		const buyerCompanyName = nullSafeGet('buyerCompany.name', workOrder) || 'Customer';
		const hasSelfManagedSupplier = compareStrings(
			nullSafeGet('buyerSupplierRelationship.relationshipStatus', sanitizedWO),
			'SelfManaged'
		);

		const workOrderDetails =
			(workOrder.id && {
				'Work Order ID': `# ${nullSafeGet('id', workOrder)}`,
				...(nullSafeGet('woNumber', workOrder) &&
					((isSupplierInitiated && !isPrivateSupplier) ||
						(isPrivateSupplier && isSupplierInitiated && !differentAssignedSupplier) ||
						(!isSupplierInitiated && isPrivateSupplier)) && {
						'Alias Work Order #': nullSafeGet('woNumber', workOrder),
					}),
				Reported: (
					<DateTimeHover
						timeZone={getWorkOrderTimeZoneId(workOrder)}
						timestamp={nullSafeGet('createdAt', workOrder)}
					/>
				),
				...(!bidderReadWO && {
					Due: (
						<DateTimeHover
							timestamp={nullSafeGet('dueDate', workOrder)}
							timeZone={getWorkOrderTimeZoneId(workOrder)}
						/>
					),
				}),
				...(sanitizedWO && sanitizedWO.nte !== undefined
					? {
							NTE: !buyerSettingsLoaded ? (
								' '
							) : skipNTEVisibilityToSuppliers ? (
								isInternalTech(currentUser) ? (
									<span className="text-grey-6">
										{supplierCurrency.format(sanitizedWO.nte)}{' '}
										<Tooltip title="NTE is hidden from service providers for this customer">
											<InfoCircleOutlined />
										</Tooltip>
									</span>
								) : (
									<Tooltip title={`${buyerCompanyName} has not made the NTE visible`}>
										<span>
											-- <InfoCircleOutlined />
										</span>
									</Tooltip>
								)
							) : (
								supplierCurrency.format(sanitizedWO.nte)
							),
					  }
					: {}),
				'Problem Type': nullSafeGetOrElse(
					'problemType.hierarchyName',
					sanitizedWO,
					nullSafeGet('problemType.name', sanitizedWO)
				),
				Area: nullSafeGet('area.hierarchyName', workOrder),
				...(getPONumbers(workOrder) && {
					'Purchase Order #': getPONumbers(workOrder),
				}),
				...(isInternalTech(currentUser) && {
					'Expense Type': nullSafeGet('isCapex', workOrder) ? 'CapEx' : 'Repair & Maintenance',
				}),
				...(isInternalTech(currentUser) &&
					nullSafeGetOrElse(
						'buyerCompany.buyerCompanySettings.config.capExConfig.acceptCapExCategory',
						workOrder,
						false
					) &&
					nullSafeGet('isCapex', workOrder) && {
						'CapEx Category': workOrder.capExCategory || '--',
					}),
				...(isInternalTech(currentUser) &&
					nullSafeGetOrElse(
						'buyerCompany.buyerCompanySettings.config.rmConfig.acceptRmCategory',
						workOrder,
						false
					) &&
					!nullSafeGet('isCapex', workOrder) && {
						'R&M Category': workOrder.rmCategory || '--',
					}),
				...optionalDetails,
				...(nullSafeGet('assetId', workOrder) &&
					nullSafeGet('isAssetDown', workOrder) && {
						'Asset Reported As': (
							<span>
								{nullSafeGet('isAssetDown', workOrder) ? 'Offline' : 'Online'}{' '}
								{nullSafeGet('asset.downtimeStatus', workOrder) === 'online' ? (
									<span className="text-xs " style={{ color: 'green' }}>
										(online now)
									</span>
								) : nullSafeGet('isAssetDown', workOrder) ? (
									<AccessPermissionChecker name={PERMISSION_NAMES.MODIFY_ASSETS}>
										<EditOutlined
											onClick={this.handleAssetStatusChange}
											className="cursor-pointer text-base"
										/>
									</AccessPermissionChecker>
								) : null}
							</span>
						),
					}),
				...(nullSafeGet('cancelledByContact', workOrder)
					? {
							'Cancelled By': (
								<UserName
									contact={nullSafeGet('cancelledByContact', workOrder)}
									mode={'inline'}
									placement={'right'}
								/>
							),
					  }
					: {}),
				...(nullSafeGet('cancelledAt', workOrder)
					? {
							'Cancelled At': (
								<DateTimeHover
									timeZone={getWorkOrderTimeZoneId(workOrder)}
									timestamp={nullSafeGet('cancelledAt', workOrder)}
								/>
							),
					  }
					: {}),
				...(nullSafeGet('completedByContact', workOrder)
					? {
							'Marked Complete By': (
								<UserName
									contact={nullSafeGet('completedByContact', workOrder)}
									mode={'inline'}
									placement={'right'}
								/>
							),
					  }
					: {}),
				...(nullSafeGet('completedAt', workOrder)
					? {
							Completed: (
								<DateTimeHover
									timeZone={getWorkOrderTimeZoneId(workOrder)}
									timestamp={nullSafeGet('completedAt', workOrder)}
								/>
							),
					  }
					: {}),
				...(nullSafeGet('resolutionTypeId', workOrder)
					? {
							'Resolution Type': nullSafeGet('resolutionType.resolutionCode', workOrder)
								? `${nullSafeGet('resolutionType.resolutionCode', workOrder)} - ${nullSafeGet(
										'resolutionType.resolutionType',
										workOrder
								  )}`
								: nullSafeGet('resolutionType.resolutionType', workOrder),
					  }
					: {}),
				estimatedCompletionDate: (
					<DateTimeHover
						timestamp={nullSafeGetOrElse(
							'estimatedCompletionDate',
							sanitizedWO,
							nullSafeGet('dueDate', workOrder)
						)}
						timeZone={getWorkOrderTimeZoneId(workOrder)}
						showDate={true}
						showTime={false}
					/>
				),
				...(approvedOrDeclinedByContactDetail && {
					[approvedOrDeclinedByContactDetail['keyName']]: (
						<UserName
							contact={approvedOrDeclinedByContactDetail['contactObject']}
							mode={'inline'}
							placement={'right'}
						/>
					),
				}),
			}) ||
			{};

		const filteredWorkOrderDetails = Object.keys(workOrderDetails).reduce((acc, el) => {
			const val = workOrderDetails[el];
			if (val !== null && val !== 'undefined' && val !== undefined && val !== '') {
				acc[el] = workOrderDetails[el];
			}
			return acc;
		}, {});

		if (error)
			return (
				<OWResult
					error={error}
					title="You no longer have access to this work order."
					subTitle="Either its deleted or been reassigned."
				/>
			);

		const associatedServiceCalls = getSupplierWorkOrderServiceCalls(
			workOrder,
			currentUser,
			isClientView
		);

		const descriptionAvailable = !!sanitizedWO.description;

		const sanitisedWO = getSanitisedWorkOrder(workOrder, isClientView);
		// The backend only hydrates subContractedFromWorkOrder when the requesting
		// facility is the subcontractor on the work order, so this is true exactly
		// when a subcontractor is looking at work sent out to them. Their contract is
		// with the contractor, not the contractor's customer, so the location drawer -
		// customer contacts, location detail, work history - stays closed to them.
		const isSubcontractorView = isSubContractedFromWorkOrder(workOrder);
		const isPendingApproval = compareStrings(nullSafeGet('displayStatus', workOrder), 'Pending');
		const moveToOnHoldDisabled = isMoveToOnHoldDisabled(workOrder, currentUser, null);
		return loading ? (
			<PageLoadingPlaceholder />
		) : (
			<Content className="workOrdersDetailDetailsPage" key={nullSafeGet('id', workOrder)}>
				{isInternalTech(currentUser) &&
					this.isAllowedToTransferWork() &&
					shouldShowSelfManagedSupplierInviteBanner(
						nullSafeGet('buyerCompany.buyerCompanySettings', workOrder),
						workOrder,
						this.state.supplierRelationship
					) && (
						<Alert
							type="warning"
							showIcon
							message={`${nullSafeGetOrElse(
								'supplierFacility.displayName',
								workOrder,
								'This service provider'
							)} is self-managed and hasn't been invited to OpenWrench.`}
							description="Invite them so they can receive updates and respond to this work order."
							action={
								<div style={{ display: 'flex', alignItems: 'center', height: '100%' }}>
									<Button type="primary" onClick={this.handleOpenInviteSupplierModal}>
										Invite service provider
									</Button>
								</div>
							}
							style={{ marginBottom: 16 }}
						/>
					)}
				{this.state.inviteSupplierModalVisible && (
					<SelfManagedSupplierEmailPromptModal
						visible
						supplierFacility={nullSafeGet('supplierFacility', workOrder)}
						onCancel={this.handleCloseInviteSupplierModal}
						onInvited={this.handleSupplierInvitedFromBanner}
					/>
				)}
				<AssetStatusForm
					downTimeHistory={this.state.downTimeHistory}
					asset={nullSafeGet('asset', workOrder)}
					onCancel={this.handleAssetStatusCancel}
					onSuccess={this.handleAssetStatusSuccess}
					visible={this.state.assetStatusChangeModalVisible}
				/>
				<StartWorkForm
					wrappedComponentRef={this.saveFormRef('startWorkForm')}
					visible={this.state.startWorkModalVisible}
					workOrderId={workOrder.id}
					onCancel={this.handleSelfManagedStartWorkCancel}
					onSubmit={this.handleSelfManagedStartWorkSubmit}
				/>
				<FinishWorkForm
					wrappedComponentRef={this.saveFormRef('finishWorkForm')}
					visible={this.state.finishWorkModalVisible}
					workOrderId={workOrder.id}
					onCancel={this.handleFinishWorkCancel}
					onSubmit={this.handleFinishWorkSubmit}
				/>
				{this.state.approveWorkModalVisible ? (
					<SupplierApproveReviewWorkForm
						wrappedComponentRef={this.saveFormRef('supplierApproveReviewWorkForm')}
						visible
						workOrderId={workOrder.id}
						onCancel={this.handleApproveWorkCancel}
						onSubmit={this.handleApproveWorkSubmit}
						onlyReview={this.state.onlyReview}
						workOrder={workOrder}
					/>
				) : null}
				<SupplierRejectReviewWorkForm
					wrappedComponentRef={this.saveFormRef('supplierRejectReviewWorkForm')}
					visible={this.state.rejectWorkModalVisible}
					workOrderId={workOrder.id}
					onCancel={this.handleRejectWorkCancel}
					onSubmit={this.handleRejectWorkSubmit}
				/>
				<ReminderForm
					wrappedComponentRef={this.saveFormRef('reminderForm')}
					visible={this.state.reminderModalVisible}
					workOrderId={workOrder.id}
					onCancel={this.handleReminderCancel}
					onSubmit={this.handleReminderSubmit}
				/>
				{this.state.scheduleServiceCallForTechAssignedFormVisible && (
					<ScheduleServiceCallModalForm
						formData={{
							...(nullSafeGetOrElse('lastServiceCall.supplierFacilityId', workOrder, -1) ===
								workOrder.supplierFacilityId && {
								...nullSafeGetOrElse('lastServiceCall', workOrder, {}),
							}),
							workOrder: workOrder,
						}}
						wrappedComponentRef={this.saveFormRef('scheduleServiceCallForTechAssignedForm')}
						visible={this.state.scheduleServiceCallForTechAssignedFormVisible}
						onCancel={this.handleScheduleForTechAssignedCancel}
						onSubmit={this.handleScheduleServiceCallForTechAssignedSubmit}
					/>
				)}
				{this.state.rescheduleServiceCallFormVisible && (
					<ScheduleServiceCallModalForm
						formData={{
							...(nullSafeGetOrElse('lastServiceCall.supplierFacilityId', sanitisedWO, -1) ===
								sanitisedWO.supplierFacilityId && {
								...nullSafeGetOrElse('lastServiceCall', sanitisedWO, {}),
							}),
							workOrder: sanitisedWO,
						}}
						isReschedule={true}
						wrappedComponentRef={this.saveFormRef('rescheduleServiceCallForm')}
						visible={this.state.rescheduleServiceCallFormVisible}
						onCancel={this.handleRescheduleServiceCallCancel}
						onSubmit={this.handleRescheduleServiceCallSubmit}
					/>
				)}
				{this.state.scheduleServiceCallFormVisible && (
					<ScheduleServiceCallModalForm
						formData={{
							workOrder: sanitisedWO,
							workOrderId: sanitisedWO.id,
							supplierFacilityId: nullSafeGetOrElse(
								'supplierFacilityId',
								sanitisedWO,
								nullSafeGet('facility.id', currentUser)
							),
						}}
						wrappedComponentRef={this.saveFormRef('scheduleServiceCallForm')}
						visible={this.state.scheduleServiceCallFormVisible}
						onCancel={this.handleScheduleServiceCallCancel}
						onSubmit={this.handleScheduleServiceCallSubmit}
					/>
				)}
				<ManualCheckInModalForm
					formData={nullSafeGetOrElse('lastServiceCall', sanitisedWO, {})}
					workOrder={sanitisedWO}
					wrappedComponentRef={this.saveFormRef('manualCheckInForm')}
					visible={this.state.manualCheckInFormVisible}
					onCancel={this.handleManualCheckInCancel}
					onSubmit={this.handleManualCheckInSubmit}
				/>
				{this.state.manualCheckOutFormVisible ? (
					<ManualCheckOutModalForm
						workOrder={workOrder}
						formData={nullSafeGetOrElse('lastServiceCall', sanitisedWO, {})}
						wrappedComponentRef={this.saveFormRef('manualCheckOutForm')}
						visible={this.state.manualCheckOutFormVisible}
						onCancel={this.handleManualCheckOutCancel}
						onSubmit={this.handleManualCheckOutSubmit}
						moveToOnHoldDisabled={isMoveToOnHoldDisabled(workOrder, currentUser, contractorWO)}
						privateSupplier={
							nullSafeGet('facility.status', currentUser) === 'private' ? true : false
						}
					/>
				) : null}
				{this.state.copyServiceCallFormVisible ? (
					<CopyServiceCallForm
						workOrder={workOrder}
						formData={this.state.selectedServiceCall}
						wrappedComponentRef={this.saveFormRef('copyServiceCallForm')}
						visible={this.state.copyServiceCallFormVisible}
						onCancel={this.copyServiceCallCancel}
						onSubmit={this.copyServiceCallSubmit}
						moveToOnHoldDisabled={isMoveToOnHoldDisabled(
							workOrder,
							currentUser,
							getContractorWO(workOrder, true)
						)}
						privateSupplier={
							nullSafeGet('facility.status', currentUser) === 'private' ? true : false
						}
					/>
				) : null}
				<PartsOrderedOrReceivedForm
					wrappedComponentRef={this.saveFormRef('partsOrderedForm')}
					title="Parts Ordered"
					visible={this.state.partsOrderedModalVisible}
					workOrderId={workOrder.id}
					onCancel={this.handlePartsOrderedCancel}
					onSubmit={this.handlePartsOrderedSubmit}
				/>
				<PartsOrderedOrReceivedForm
					wrappedComponentRef={this.saveFormRef('partsReceivedForm')}
					title="Parts Received"
					visible={this.state.partsReceivedModalVisible}
					workOrderId={workOrder.id}
					onCancel={this.handlePartsReceivedCancel}
					onSubmit={this.handlePartsReceivedSubmit}
				/>
				<PartsRequestedForm
					wrappedComponentRef={this.saveFormRef('partsRequestedForm')}
					visible={this.state.partsRequestedModalVisible}
					workOrderId={workOrder.id}
					onCancel={this.handlePartsRequestedCancel}
					onSubmit={this.handlePartsRequestedSubmit}
				/>
				<BackDateWorkOrderModalForm
					formData={workOrder}
					wrappedComponentRef={this.saveFormRef('backDaterWorkOrderForm')}
					visible={this.state.backDateWorkOrderFormVisible}
					onCancel={this.handlebackDateWorkOrderCancel}
					onSubmit={this.handlebackDaterWorkOrderSubmit}
				/>
				<EstimatedDateWorkOrderModalForm
					formData={sanitizedWO}
					wrappedComponentRef={this.saveFormRef('estimatedDaterWorkOrderForm')}
					visible={this.state.estimatedDateWorkOrderFormVisible}
					onCancel={this.handleEstimatedDateWorkOrderCancel}
					onSubmit={this.handleEstimatedDateWorkOrderSubmit}
				/>
				{this.state.addDetailModalVisible ? (
					<WOAdditionalDetailsModal
						workOrder={sanitisedWO}
						onCancel={this.hideAddDetailModal}
						onSuccess={this.onAddDetailSuccess}
						isClientView={isClientView}
					/>
				) : null}
				{this.state.addAssociateAssetModalVisible ? (
					<SupplierAssociateAssetInWorkOrder
						workOrder={sanitisedWO}
						onCancel={this.hideAssociateAssetModal}
						onSuccess={this.onAssociateAssetSuccess}
						isClientView={isClientView}
					/>
				) : null}
				<Row gutter={16}>
					<Col lg={24} xl={16}>
						{this.state.tasksSectionVisible ? (
							<div className="rowSpacing">
								<WOTasksSection workOrder={workOrder} />
							</div>
						) : null}
						<div className="rowSpacing">
							<Card
								bodyStyle={{ padding: 0 }}
								title="Work Order Details"
								extra={
									<div className="flex flex-row items-center">
										{bidderReadWO ? null : (
											<AddTasksButton
												workOrder={workOrder}
												tasksSectionVisible={this.state.tasksSectionVisible}
												showAddTasks={this.showAddTasks}
											/>
										)}
										{!bidderReadWO && !descriptionAvailable ? (
											<Button
												className="list_button mr-2"
												size="small"
												type="link"
												onClick={this.showAddDetailModal}
											>
												Add Details
											</Button>
										) : null}
										{allowAssetAssociationByThirdPartySuppliers ? (
											<Button
												className="list_button mr-2"
												size="small"
												type="link"
												onClick={this.showAssociateAssetModal}
											>
												Associate an Asset
											</Button>
										) : null}
										{!bidderReadWO ? (
											<WorkOrderPrintable workOrder={sanitisedWO} companyConfig={companyConfig} />
										) : null}
									</div>
								}
							>
								<div className="materialCard__body">
									{bidderReadWO ? null : isInternalTech(currentUser) ? (
										<WorkOrderActions
											workOrder={workOrder}
											showApproveModal={this.showApproveModal}
											showReminderModal={this.showReminderModal}
											currentUser={currentUser}
											companyConfig={nullSafeGet('detail', companyConfig)}
											refreshWorkOrder={this.refreshWorkOrder}
											reviewAndCompleteDisabled={!reviewAndCompleteAllowed}
										/>
									) : reviewAndCompleteAllowed ? (
										<ReviewAndMarkCompleteComponent
											workOrder={workOrder}
											isThirdPartySupplier
											markWorkOrderCompleteByThirdParty={this.markWorkOrderWaitingForReview}
											isClientView={isClientView}
										/>
									) : null}
									{descriptionAvailable ? (
										<div className="flex max-w-full flex-row items-start justify-between">
											<div className="flex w-full max-w-full flex-col">
												<div className="materialCard__primaryTitle max-w-full">
													<div
														style={{ fontSize: 16 }}
														className="richTextWrapper"
														dangerouslySetInnerHTML={{
															__html: sanitizedWO.description,
														}}
													/>
												</div>
											</div>
											{bidderReadWO || !isClientView ? null : (
												<Button
													type="link"
													icon={<EditOutlined onClick={this.showAddDetailModal} />}
												/>
											)}
										</div>
									) : null}
									{workOrder.images && workOrder.images.length > 0 ? (
										<div className="materialCard__subtitle">
											{
												<ProtectedImageThumbnails
													style={{ marginBottom: 32 }}
													imageWidth={160}
													imageHeight={160}
													photoStrings={workOrder.images}
													convertedImages={workOrder.convertedImages}
													role={ROLE_TYPES.SUPPLIER}
												/>
											}
										</div>
									) : null}
									<div className="materialCard__supportingText">
										<KeyValueDisplay
											horizontal={true}
											keyWidth={120}
											keyValueStore={filteredWorkOrderDetails}
											keyAliases={{
												Reported: (
													<span>
														Reported{' '}
														<AccessPermissionChecker
															name={PERMISSION_NAMES.CAN_BACKDATE_WORK_ORDER}
														>
															<EditOutlined
																onClick={this.handlebackDate}
																className="font-base cursor-pointer"
															/>
														</AccessPermissionChecker>
													</span>
												),
												estimatedCompletionDate: (
													<span>
														Estimated Completion Date{' '}
														{[
															WORK_ORDER_DISPLAY_STATUSES.cancelled,
															WORK_ORDER_DISPLAY_STATUSES.complete,
														].includes(sanitizedWO.displayStatus) ? null : isClientView ? (
															<EditOutlined
																onClick={this.handleEstimatedDate}
																className="font-base cursor-pointer"
															/>
														) : null}
													</span>
												),
											}}
										/>
									</div>
								</div>
							</Card>
						</div>

						<TroubleshootingDetailDisplay workOrder={workOrder} />

						{bidderReadWO ? null : hasSelfManagedSupplier ? (
							<SelfManagementServiceCall
								currentUser={currentUser}
								workOrder={sanitisedWO}
								handleStartWork={this.handleSelfManagedStartWork}
								handlePartsReceived={this.handlePartsReceived}
								handleFinishWork={this.handleFinishWork}
								handlePartsOrdered={this.handlePartsOrdered}
								moveToOnHoldDisabled={moveToOnHoldDisabled}
							/>
						) : associatedServiceCalls.length > 0 ? (
							<div className="rowSpacing">
								<Card title="Service Calls">
									{sanitisedWO.status === WORK_ORDER_STATUSES.techAssigned ? (
										<div>
											{differentAssignedSupplier ? (
												<div style={{ fontSize: 16, maxWidth: 480 }}>
													Ready to schedule service call for{' '}
													{nullSafeGet('supplierFacility.name', sanitisedWO)}?
												</div>
											) : (
												<div style={{ fontSize: 16, maxWidth: 480 }}>
													Ready to schedule service call?
												</div>
											)}
											<div style={{ marginTop: 16, marginBottom: 40 }}>
												<Button
													type="primary"
													key="schedule"
													disabled={!!this.state.actionButtonLoading}
													onClick={this.handleScheduleForTechAssigned}
												>
													Schedule Service
												</Button>
												{isTechEnRouteEnabled && !differentAssignedSupplier ? (
													<Button
														key="enRoute"
														loading={this.state.actionButtonLoading === 'scheduleAndTechEnRoute'}
														disabled={disabledByAnotherAction(
															this.state.actionButtonLoading,
															'scheduleAndTechEnRoute'
														)}
														style={{ marginLeft: 16 }}
														onClick={this.scheduleAndTechEnRoute}
													>
														En Route
													</Button>
												) : null}
												{differentAssignedSupplier ? null : (
													<AccessPermissionChecker
														name={PERMISSION_NAMES.REMOTE_CHECK_IN_OR_CHECK_OUT_ALLOWED}
													>
														<Button
															key="startWork"
															loading={this.state.actionButtonLoading === 'startWork'}
															disabled={disabledByAnotherAction(
																this.state.actionButtonLoading,
																'startWork'
															)}
															style={{ marginLeft: 16 }}
															onClick={this.handleStartWorkForTechAssigned}
														>
															Start Work
														</Button>
													</AccessPermissionChecker>
												)}
												{nullSafeGet('id', contractWO) || moveToOnHoldDisabled ? null : (
													<Button
														key="partsOnOrder"
														disabled={!!this.state.actionButtonLoading}
														onClick={this.handlePartsOrdered}
														style={{ marginLeft: 16 }}
													>
														Parts Ordered
													</Button>
												)}
											</div>
										</div>
									) : SCHEDULE_TECH_STATUSES.includes(sanitisedWO.status) ? (
										<div>
											{differentAssignedSupplier ? (
												<div style={{ fontSize: 16, maxWidth: 480 }}>
													Ready to schedule service call for{' '}
													{nullSafeGet('supplierFacility.name', sanitisedWO)}?
												</div>
											) : (
												<div style={{ fontSize: 16, maxWidth: 480 }}>
													Ready to schedule service call?
												</div>
											)}
											<div style={{ marginTop: 16, marginBottom: 40 }}>
												<Button
													type="primary"
													key="schedule"
													disabled={!!this.state.actionButtonLoading}
													onClick={this.handleSchedule}
												>
													Schedule Service
												</Button>
												{isTechEnRouteEnabled && !differentAssignedSupplier ? (
													<Button
														key="enRoute"
														loading={this.state.actionButtonLoading === 'scheduleAndTechEnRoute'}
														disabled={disabledByAnotherAction(
															this.state.actionButtonLoading,
															'scheduleAndTechEnRoute'
														)}
														style={{ marginLeft: 16 }}
														onClick={this.scheduleAndTechEnRoute}
													>
														En Route
													</Button>
												) : null}
												{nullSafeGet('id', contractWO) || moveToOnHoldDisabled ? null : (
													<>
														{differentAssignedSupplier ? null : nullSafeGetOrElse(
																'detail.config.partsOrderingConfig.needPartsRequisitionBeforeOrdering',
																companyConfig,
																false
														  ) &&
														  sanitisedWO.status !== WORK_ORDER_STATUSES.partsRequested &&
														  sanitisedWO.status !== WORK_ORDER_STATUSES.partsOnOrder ? (
															<Button
																key="partsRequested"
																disabled={!!this.state.actionButtonLoading}
																onClick={this.handlePartsRequested}
																style={{ marginLeft: 16 }}
															>
																Request Parts
															</Button>
														) : sanitisedWO.status !== WORK_ORDER_STATUSES.partsOnOrder ? (
															<Button
																key="partsOnOrder"
																disabled={!!this.state.actionButtonLoading}
																onClick={this.handlePartsOrdered}
																style={{ marginLeft: 16 }}
															>
																Parts Ordered
															</Button>
														) : (
															<Button
																key="partsReceived"
																disabled={!!this.state.actionButtonLoading}
																onClick={this.handlePartsReceived}
																style={{ marginLeft: 16 }}
															>
																Parts Received
															</Button>
														)}
													</>
												)}
											</div>
										</div>
									) : null}
									<SupplierServiceCallDetails
										workOrder={sanitisedWO}
										handleManualCheckOut={this.handleManualCheckOut}
										showApproveModal={this.showApproveModal}
										showRejectModal={this.showRejectModal}
										handleReschedule={this.handleReschedule}
										handleManualCheckIn={this.handleManualCheckIn}
										copyServiceCall={this.copyServiceCall}
										handleTechEnRoute={this.handleTechEnRoute}
										actionButtonLoading={this.state.actionButtonLoading}
										refreshWorkOrder={this.refreshWorkOrder}
									/>
								</Card>
							</div>
						) : (
							//Internal Technicians?
							<div className="rowSpacing">
								<Card title="Service Calls">
									<div>
										{differentAssignedSupplier ? (
											<div style={{ fontSize: 16 }}>
												{nullSafeGet('supplierFacility.name', workOrder)} hasn't scheduled a service
												call for this work order yet.
											</div>
										) : isPendingApproval ? (
											<div style={{ fontSize: 16 }}>
												Customer must approve work order before a service call can be scheduled.
											</div>
										) : isClientView ? (
											<div style={{ fontSize: 16 }}>
												You haven't scheduled a service call for this work order yet.
											</div>
										) : (
											<div style={{ fontSize: 16 }}>
												Your subcontractor hasn't scheduled a service call for this work order yet.
											</div>
										)}
										{NOT_SCHEDULABLE_STATUSES.includes(workOrder.status) ? null : (
											<div style={{ marginTop: 16, marginBottom: 40 }}>
												<Button
													type="primary"
													key="schedule"
													disabled={!!this.state.actionButtonLoading}
													onClick={this.handleSchedule}
												>
													Schedule Service
												</Button>
												{isTechEnRouteEnabled && !differentAssignedSupplier ? (
													<Button
														key="enRoute"
														loading={this.state.actionButtonLoading === 'scheduleAndTechEnRoute'}
														disabled={disabledByAnotherAction(
															this.state.actionButtonLoading,
															'scheduleAndTechEnRoute'
														)}
														style={{ marginLeft: 16 }}
														onClick={this.scheduleAndTechEnRoute}
													>
														En Route
													</Button>
												) : null}
												{differentAssignedSupplier ? null : (
													<AccessPermissionChecker
														name={PERMISSION_NAMES.REMOTE_CHECK_IN_OR_CHECK_OUT_ALLOWED}
													>
														<Button
															key="startWork"
															loading={this.state.actionButtonLoading === 'startWork'}
															disabled={disabledByAnotherAction(
																this.state.actionButtonLoading,
																'startWork'
															)}
															style={{ marginLeft: 16 }}
															onClick={this.handleStartWork}
														>
															Start Work
														</Button>
													</AccessPermissionChecker>
												)}
												{nullSafeGet('id', contractWO) || moveToOnHoldDisabled ? null : (
													<>
														{differentAssignedSupplier ? null : nullSafeGetOrElse(
																'detail.config.partsOrderingConfig.needPartsRequisitionBeforeOrdering',
																companyConfig,
																false
														  ) && workOrder.status !== WORK_ORDER_STATUSES.partsRequested ? (
															<Button
																key="partsRequested"
																disabled={!!this.state.actionButtonLoading}
																onClick={this.handlePartsRequested}
																style={{ marginLeft: 16 }}
															>
																Request Parts
															</Button>
														) : workOrder.status !== WORK_ORDER_STATUSES.partsOnOrder ? (
															<Button
																key="partsOnOrder"
																disabled={!!this.state.actionButtonLoading}
																onClick={this.handlePartsOrdered}
																style={{ marginLeft: 16 }}
															>
																Parts Ordered
															</Button>
														) : (
															<Button
																key="partsReceived"
																disabled={!!this.state.actionButtonLoading}
																onClick={this.handlePartsReceived}
																style={{ marginLeft: 16 }}
															>
																Parts Received
															</Button>
														)}
													</>
												)}
											</div>
										)}
									</div>
								</Card>
							</div>
						)}
					</Col>
					<Col lg={24} xl={8}>
						{canAccessInternalWorkspace(currentUser) ? <InternalNotesPreviewCard /> : null}
						{bidderReadWO ? null : workOrder.id ? (
							isPrivateSupplier ? (
								<>
									<div className="rowSpacing">
										<Card
											title={
												<Tooltip title="These attachments are visible to the client.">
													<span>Client Attachments</span>
												</Tooltip>
											}
										>
											<FileUploader
												roleType="supplier"
												defaultFileList={workOrder.buyerAttachments || []}
												convertedImages={workOrder.convertedImages}
												handleUploadSuccess={this.handleFileAttachmentUploadChange}
												uploaderType={'dragger'}
											/>
										</Card>
									</div>
									{nullSafeGet('supplierAttachments.0', workOrder) ? (
										<div className="rowSpacing">
											<Card title="Service Provider Attachments">
												<FileUploader
													roleType="supplier"
													defaultFileList={workOrder.supplierAttachments || []}
													convertedImages={workOrder.convertedImages}
													uploaderType={'readOnly'}
												/>
											</Card>
										</div>
									) : null}
								</>
							) : isClientView ? (
								<div>
									<div className="rowSpacing">
										<Card
											title={
												<Tooltip title="These attachments are visible to the client.">
													<span>Client Attachments</span>
												</Tooltip>
											}
										>
											<FileUploader
												roleType="supplier"
												defaultFileList={sanitizedWO.supplierAttachments || []}
												convertedImages={sanitizedWO.convertedImages}
												handleUploadSuccess={this.handleFileAttachmentUploadChange}
												uploaderType={'dragger'}
											/>
										</Card>
									</div>
									{nullSafeGet('contractorAttachments.0', sanitizedWO) ? (
										<div className="rowSpacing">
											<Card title="Contractor Attachments">
												<FileUploader
													roleType="supplier"
													defaultFileList={sanitizedWO.contractorAttachments || []}
													convertedImages={sanitizedWO.convertedImages}
													handleUploadSuccess={this.handleFileAttachmentUploadChange}
													uploaderType={'readOnly'}
												/>
											</Card>
										</div>
									) : null}
								</div>
							) : (
								<>
									<div className="rowSpacing">
										<Card
											title={
												<Tooltip title="These attachments are visible to the subcontractor.">
													<span>Subcontractor Attachments</span>
												</Tooltip>
											}
										>
											<FileUploader
												roleType="supplier"
												defaultFileList={sanitizedWO.supplierAttachments || []}
												convertedImages={sanitizedWO.convertedImages}
												handleUploadSuccess={this.handleFileAttachmentUploadChange}
												uploaderType={'dragger'}
											/>
										</Card>
									</div>
									{nullSafeGet('subContractorAttachments.0', sanitizedWO) ? (
										<div className="rowSpacing">
											<Card title="Subcontractor Attachments">
												<FileUploader
													roleType="supplier"
													defaultFileList={sanitizedWO.subContractorAttachments || []}
													convertedImages={sanitizedWO.convertedImages}
													uploaderType={'readOnly'}
												/>
											</Card>
										</div>
									) : null}
								</>
							)
						) : null}

						{isPrivateSupplier && workOrder.id ? (
							<QuestionnaireSurvey workOrder={workOrder} />
						) : null}
						{nullSafeGet('id', workOrder) ? <WorkOrderRating workOrder={workOrder} /> : null}
						{!workOrder.id || isPrivateSupplier ? null : workOrder.buyerAttachments === undefined ||
						  workOrder.buyerAttachments.length === 0 ? null : (
							<div className="rowSpacing">
								<Card title="Customer Attachments">
									<FileUploader
										roleType="supplier"
										defaultFileList={workOrder.buyerAttachments || []}
										convertedImages={workOrder.convertedImages}
										uploaderType={'readOnly'}
									/>
								</Card>
							</div>
						)}
						{nullSafeGet('contractorClient', sanitisedWO) ? (
							<div className="rowSpacing">
								<ContractorClientCardDisplay
									contractorClient={nullSafeGet('contractorClient', sanitisedWO)}
								/>
							</div>
						) : null}
						{nullSafeGet('location.id', workOrder) ? (
							<div className="rowSpacing">
								<SupplierLocationCardDisplay
									location={workOrder.location}
									disableDrawer={isSubcontractorView}
									onViewLocationPage={() =>
										history.push(
											`/supplier/locations/detail/${nullSafeGet('location.id', workOrder)}`
										)
									}
								/>
							</div>
						) : nullSafeGet('location', sanitisedWO) ? (
							<div className="rowSpacing">
								<ContractorLocationDisplayCard
									contractorLocation={nullSafeGet('location', sanitisedWO)}
									disableDrawer={isSubcontractorView}
								/>
							</div>
						) : null}
						{nullSafeGet('plannedMaintenanceSchedule.title', workOrder) ? (
							<div className="rowSpacing">
								<Card title="Planned Maintenance Schedule">
									<div className="mb-4">
										{isAdminUser(currentUser) ? (
											<HyperLink
												text={
													<span className="text-lg font-bold text-black">
														{workOrder.plannedMaintenanceSchedule.title}
													</span>
												}
												newTabPath={`/${userType}/plannedMaintenance/detail/${safeEncodeURIComponent(
													nullSafeGet('plannedMaintenanceSchedule.title', workOrder)
												)}/${encodeURIComponent(
													nullSafeGet('plannedMaintenanceSchedule.frequency', workOrder)
												)}/${encodeURIComponent(
													nullSafeGet(
														'plannedMaintenanceSchedule.plannedMaintenanceTemplateId',
														workOrder
													)
												)}/${encodeURIComponent(
													nullSafeGet('plannedMaintenanceSchedule.basedOn', workOrder)
												)}/details`}
											/>
										) : (
											<span className="text-lg font-bold text-black">
												{workOrder.plannedMaintenanceSchedule.title}
											</span>
										)}
										{workOrder.plannedMaintenanceSchedule.additionalInfo ? (
											<div
												style={{ fontSize: 16 }}
												className="richTextWrapper"
												dangerouslySetInnerHTML={{
													__html: nullSafeGetOrElse(
														'plannedMaintenanceSchedule.additionalInfo',
														workOrder,
														''
													),
												}}
											/>
										) : null}
									</div>

									<div className="flex flex-row items-center justify-between">
										<div className="plannedMaintenanceSchedulesRowDisplay__rowInlineGroup">
											<i className="icons8-font icons8-settings"></i>{' '}
											{workOrder.plannedMaintenanceSchedule.basedOn === 'asset'
												? 'Asset Based'
												: workOrder.plannedMaintenanceSchedule.basedOn === 'assetType'
												? 'Asset Type Based'
												: 'Location Based'}
										</div>
										<div className="plannedMaintenanceSchedulesRowDisplay__rowInlineGroup">
											<i className="icons8-font icons8-calendar"></i>{' '}
											{workOrder.plannedMaintenanceSchedule.frequency}
										</div>
									</div>

									{nullSafeGet(
										'plannedMaintenanceSchedule.plannedMaintenanceTemplate.attachments.length',
										workOrder
									) ? (
										<div className="materialCard__subtitle mt-4 text-lg font-semibold underline">
											Attachments:
											<FileUploader
												roleType={userType}
												defaultFileList={nullSafeGetOrElse(
													'plannedMaintenanceSchedule.plannedMaintenanceTemplate.attachments',
													workOrder,
													[]
												)}
												convertedImages={nullSafeGet(
													'plannedMaintenanceSchedule.plannedMaintenanceTemplate.convertedImages',
													workOrder
												)}
												uploaderType={'readOnly'}
											/>
										</div>
									) : null}

									{nullSafeGet(
										'plannedMaintenanceSchedule.supplierContractDocuments.length',
										workOrder
									) ? (
										<div className="mt-4  font-medium">
											Contract Details:
											<FileUploader
												roleType={userType}
												defaultFileList={
													workOrder.plannedMaintenanceSchedule.supplierContractDocuments || []
												}
												convertedImages={nullSafeGet(
													'plannedMaintenanceSchedule.convertedImages',
													workOrder
												)}
												uploaderType={'readOnly'}
											/>
										</div>
									) : null}
								</Card>
							</div>
						) : null}
						{nullSafeGet('asset', workOrder) ? (
							<div className="rowSpacing">
								<AssetCardDisplay
									asset={workOrder.asset}
									subAssets={nullSafeGet('subAssets', workOrder)}
								/>
							</div>
						) : null}
						{bidderReadWO || (!isInternalTech(currentUser) && !!contractorWO) ? null : nullSafeGet(
								'supplierFacility',
								workOrder
						  ) ? (
							<div className="rowSpacing">
								<ServiceProviderCardDisplay workOrder={workOrder} />
							</div>
						) : null}
						{bidderReadWO ? null : !!contractWO ? (
							<div className="rowSpacing">
								<SubContractorCardDisplay workOrder={workOrder} isClientView={isClientView} />
							</div>
						) : null}
						<div className="rowSpacing">
							<WorkOrderInternalContact workOrder={workOrder} />
						</div>
					</Col>
				</Row>
			</Content>
		);
	}
}

const mapStateToProps = (state, ownProps) => ({
	workOrdersFetching: state.work_orders.fetching,
	workOrder: getEntityById(ownProps.match.params.id, state.work_orders),
	currentUser: state.session.currentUser,
	companyConfig: state.company_config,
	match: ownProps.match,
	history: ownProps.history,
	userType: state.session.userType,
	isClientView: state.clientView.isClientView,
});

const mapDispatchToProps = (dispatch) => ({
	scheduleServiceCall: (serviceCall) => dispatch(scheduleServiceCallForSupplier(serviceCall)),
	scheduleServiceCallForContractor: (serviceCall) =>
		dispatch(scheduleServiceCallForContractor(serviceCall)),
	copyContractorServiceCallAction: (serviceCall) =>
		dispatch(copyContractorServiceCall(serviceCall)),
	startWorkOrder: (entity) => dispatch(startWorkOrderForSupplier(entity)),
	finishWorkOrder: (entity) => dispatch(finishWorkOrderForSupplier(entity)),
	rescheduleServiceCall: (serviceCall) => dispatch(rescheduleServiceCallForSupplier(serviceCall)),
	rescheduleServiceCallForContractor: (serviceCall) =>
		dispatch(rescheduleServiceCallForContractor(serviceCall)),
	handleTechEnRouteServiceCall: (entity) => dispatch(techEnRouteServiceCallForSupplier(entity)),
	handleTechEnRouteServiceCallForContractor: (entity, contractorWOKey) =>
		dispatch(techEnRouteContractorWorkOrder(entity, contractorWOKey)),
	handleWorkUnsatifactoryForContractor: (entity, contractorWOKey) =>
		dispatch(workUnsatisfactoryContractorWorkOrder(entity, contractorWOKey)),
	reviewWorkOrderAndMarkComplete: (entity) =>
		dispatch(reviewWorkOrderAndMarkCompleteForSupplier(entity)),
	approveWorkOrderServiceCallForContractor: (entity) =>
		dispatch(approveWorkOrderServiceCallForContractor(entity)),
	reviewInternalTechWorkOrderAndMarkComplete: (entity) =>
		dispatch(reviewInternalTechWorkOrderAndMarkCompleteForSupplier(entity)),
	markCompletedByThirdParty: (entity) => dispatch(markCompletedByThirdPartyForSupplier(entity)),
	reviewWorkOrderAndMarkUnsatisfactory: (entity) =>
		dispatch(reviewWorkOrderAndMarkUnsatisfactoryForSupplier(entity)),
	manualCheckIn: (serviceCall) => dispatch(manualCheckInServiceCallForSupplier(serviceCall)),
	manualCheckInForContractor: (serviceCall) =>
		dispatch(manualCheckInServiceCallForContractor(serviceCall)),
	manualCheckOut: (serviceCall) => dispatch(manualCheckOutServiceCallForSupplier(serviceCall)),
	manualCheckOutForContractor: (serviceCall) =>
		dispatch(manualCheckOutServiceCallForContractor(serviceCall)),
	getWorkOrder: (id) => dispatch(workOrdersRestCrudThunksForSupplier.readOne(id)),
	updateWorkOrderPartially: (id, entity) =>
		dispatch(workOrdersRestCrudThunksForSupplier.updatePartially(id, entity)),
	createServiceCall: (entity) => dispatch(serviceCallsRestCrudThunksForSupplier.create(entity)),
	appendWorkOrderNotes: (entity) => dispatch(appendWorkOrderNotesForSupplier(entity)),
	partsOrderedWorkOrder: (entity) => dispatch(partsOrderedWorkOrderForSupplier(entity, 'id')),
	partsReceivedWorkOrder: (entity) => dispatch(partsReceivedWorkOrderForSupplier(entity, 'id')),
	partsRequestedWorkOrder: (entity) => dispatch(partsRequestedWorkOrderForSupplier(entity, 'id')),
	archiveWorkOrder: (entity) =>
		dispatch(workOrdersRestCrudThunksForSupplier.archive(entity, 'id', true)),
	unarchiveWorkOrder: (entity) =>
		dispatch(workOrdersRestCrudThunksForSupplier.unarchive(entity, 'id', true)),
	acceptWorkOrder: (entity) => dispatch(acceptWorkOrderForSupplier(entity, 'id')),
	declineWorkOrder: (entity) => dispatch(declineWorkOrderForSupplier(entity, 'id')),
	cancelWorkOrder: (entity) => dispatch(cancelWorkOrderForSupplier(entity)),
	markUserNotificationsRead: (entityId) =>
		dispatch(markUserNotificationsReadForSupplier('WorkOrder', entityId)),
	updateWorkOrderResolutionType: (workOrderId, resolutionTypeId) =>
		dispatch(updateWorkOrderResolutionTypeForSupplier(workOrderId, resolutionTypeId)),
	backDataWorkOrder: (entity, reportedAt) =>
		dispatch(backDataWorkOrderForSupplier(entity, reportedAt)),
	getAssetDowntime: (params, userType) => dispatch(assetDowntimeGet(userType)(params)),
	updateSubContractorInfo: (entity) => dispatch(updateContractWorkOrder(entity, 'id')),
	fetchSupplierRelationship: (params) => dispatch(supplierPrivateNetworksV2ForSupplier(params)),
	updateWorkOrderPartiallyInRedux: (workOrder) =>
		dispatch(WORK_ORDERS_CRUD_ACTION_CREATORS.updatePartialSuccess(workOrder)),
});

export default withRouter(
	connect(mapStateToProps, mapDispatchToProps)(SupplierWorkOrdersDetailPage)
);
